import React, { Component } from 'react';
import { UserId } from '../helpers/User';
import { domainUrl } from '../config/Config';
import {
    getUserData,
    reactLoader,
    getTokenData,
    composcroll,
    contentResizeLoad,
    message,
    scrollToTop,
    showLargeLeftMenu,
    hideleftbar
} from '../helpers/Common';
import Main from '../layouts/Main';
import Contracts from './Contracts';
import Anouncement from './Anouncement';
import Courseworkcomp from './Courseworkcomp';
import Videocomponent from './Videocomponent';
import Practiceassigment from './Practiceassigment';
import ContextQuestionnaire from './ContextQuestionnaire';
import FeedbackForm from './FeedbackForm';
import Recordedvideo from './Recordedvideo';
import Webcastlive from './Webcastlive';
import EvaluationForm from './EvaluationForm';
import Thanks from './Thanks';
import Descriptivetask3 from './Descriptivetask3';
import Normaltest from './Normaltest';
import RepeatNormaltest from './RepeatNormaltest';
import Testonebyone from './Testonebyone';
import RepeatTestonebyone from './RepeatTestonebyone';
import Timevariabletest from './Timevariabletest';
import RepeatTimevariabletest from './RepeatTimevariabletest';
import Fixedtimetest from './Fixedtimetest';
import RepeatFixedtimetest from './RepeatFixedtimetest';
import GridComp from './GridComp';
import BetTest from './BetTest';
import WritingNotePad from './partials/WritingNotePad';
import Testresults from './Testresults';
import Ctestonebyone from './Ctestonebyone';

const jQuery = window.jQuery;
export default class Componetlist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            writingPadData: [],
            component_type: "",
            componentPanel: "",
            learning_room_name: "",
            lrcomponents: [],
            auto_visible: [],
            defaultLrID: getUserData('defaultLRID', true),
            allowshowthanks:false,
        };
        this.lr_id = (props.lr_id == 0) ? this.state.defaultLrID : props.lr_id;
        this.dlrid = (props.dlr_id == 0) ? 0 : props.dlr_id;
        this.compolist = this.compolist.bind(this);
        this.anncompolist = this.anncompolist.bind(this);
        this.goToNotesList = this.goToNotesList.bind(this);
        this.returntestresult = this.returntestresult.bind(this);
        this.returnrepeatretest=this.returnrepeatretest.bind(this);
    }
    getLearningRoom(id, dlr_id) {
        reactLoader("show", "Please wait...");
        fetch(domainUrl + 'guidedpath/components', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                learner_id: UserId(),
                room_id: id,
                dlr_id: dlr_id
            })
        }).then((response) => {
            if (response.ok) {
                reactLoader("hide");
                return response.json()
            } else {
                return response.json()
            }
        }).then((responseJson) => {
            this.setState({
                writingPadData: responseJson,
                lrcomponents: responseJson.lrcomponents,
                learning_room_name: responseJson.lr_name,
                auto_visible: responseJson.auto_visible
            });
            jQuery(".guided_path li").removeClass("active-accordion");
            jQuery('.lr' + this.lr_id).addClass("active-accordion");
            // jQuery('.modu_' + this.lr_id).addClass("active-accordion");
            jQuery('.mlr_' + this.lr_id).parents('li').addClass("active-accordion");
            jQuery('li.mlr_' + this.lr_id).addClass("active-accordion");
            jQuery('.mrlr_' + this.lr_id).parents('li').addClass("active-accordion");
            jQuery('li.mrlr_' + this.lr_id).addClass("active-accordion");
            let responselrcomponent=this.state.lrcomponents;
           if(responselrcomponent!=undefined && responselrcomponent!=null) {
            Object.keys(responselrcomponent).map((item, i) => {
                //console.log(responselrcomponent);   
                if(responselrcomponent[item].length>1)
                {
                    
                    let responselrcomponentitem=responselrcomponent[item];
                    responselrcomponentitem.map((itemof, k) => {
                       if(itemof.status!="completed")
                        {
                            this.setState({allowshowthanks:true});
                        }    
                    });
                }
               
                else if(responselrcomponent[item].length==0 &&  responselrcomponent[item].status!="completed")
                {
                   
                    this.setState({allowshowthanks:true});
                } 
                
             });
            }
            this.openthecompoents(responseJson.lrcomponents);
            setTimeout(() => {
                composcroll();
                contentResizeLoad();
                hideleftbar();
            }, 400);
          
        });
    }
    predividernotcompleted() {
        //message('Note!', 'You will be able to open this component only after completing the current Active Components', 'info');
        message('Note!', 'Please complete the items listed above the Gray line first', 'info');
    }
    goToNotesList(type, lr_id, dlr_id) {
        this.props.switchPanel(type, lr_id, dlr_id);
    }
    opencompoentscase(data) {
        let panel = [];
        let isScroll = 1;
        
        switch (data.compo_type) {
            case "contract":
                panel = <Contracts data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "anouncement":
                panel = <Anouncement data={data} usableType="webapp" switchback={this.anncompolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "videocomponent":
                panel = <Videocomponent data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "coursework":
                panel = <Courseworkcomp data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "practice":
                panel = <Practiceassigment data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "descriptivetask":
                panel = <Descriptivetask3 data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "context":
                panel = <ContextQuestionnaire data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "feedbackform":
                panel = <FeedbackForm data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "recordedvideo":
                panel = <Recordedvideo data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "webcastlive":
                panel = <Webcastlive data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "evaluation":
                panel = <EvaluationForm data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "normaltest":
                panel = <Normaltest data={data} usableType="webapp" switchback={this.returntestresult} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "repeatnormaltest":
                panel = <RepeatNormaltest data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;    
            case "testonebyone":
                panel = <Testonebyone data={data} usableType="webapp" switchback={this.returntestresult} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "repeattestonebyone":
                panel = <RepeatTestonebyone data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;    
            case "testgoback":
                panel = <Testonebyone data={data} usableType="webapp" switchback={this.returntestresult} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "timevariabletest":
                panel = <Timevariabletest data={data} usableType="webapp" switchback={this.returntestresult} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "repeattimevariabletest":
                panel = <RepeatTimevariabletest data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;    
            case "fixedtimetest":
                panel = <Fixedtimetest data={data} usableType="webapp" switchback={this.returntestresult} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "repeatfixedtimetest":
                panel = <RepeatFixedtimetest data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;    
            case "girdcomponent":
                panel = <GridComp data={data} usableType="webapp" switchback={this.compolist} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "bet_test":
                panel = <BetTest data={data} usableType="webapp" switchback={this.returntestresult} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "testresults":
                panel = <Testresults data={data} usableType="webapp" switchback={this.compolist} switchrepeatretest={this.returnrepeatretest} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "ctestonebyone":
                panel = <Ctestonebyone data={data} usableType="webapp" switchback={this.returntestresult} returnthanks={this.returntestresult} />;
                isScroll = 0;
                break;
            case "thanks":
                panel = <Thanks data={data} usableType="webapp" switchback={this.compolist} />;
                isScroll = 0;
                break;
            default:
                Object.keys(this.state.lrcomponents).map((did, index) => {
                    if (this.state.auto_visible[index] !== undefined) {
                        panel = this.openthecompoents(this.state.auto_visible[index]);
                    } else {
                        let testtxt = <div key={`lrcomponents_${index}`} id={`lrcomponents_${index}`} className="box gc">
                            <ul key={`ui$index`} className={index}>{this.getdividcomponents(did)}</ul>
                        </div>
                        if (panel != undefined) {
                            panel.push(testtxt);
                        }
                    }
                });
        }
        scrollToTop();
        if (panel !== undefined) {
            this.setState({
                componentPanel: panel,
                component_type: isScroll
            });
        }
    }
    compolist(type, lr_id, dlr_id) {
        this.opencompoentscase({ type, lr_id, dlr_id });
        this.getLearningRoom(lr_id, dlr_id);
    }
    anncompolist(responseJson) {
        this.opencompoentscase(responseJson);
        if (responseJson.look_before == undefined) {
            this.getLearningRoom(responseJson.learning_room_id, responseJson.dlr_id);
        }
        scrollToTop();
    }
    returntestresult(testresultData) {
        // alert('ttt321');
        // console.log(testresultData);
        
        // if(testresultData.status=='completed')
        // {
        //     this.setState({allowshowthanks:true}); 
        // }
       //check allow thanks page
       if(this.state.allowshowthanks==true || testresultData.status=='completed' || (testresultData.is_betcomponent=='1' && testresultData.betallowcomp!=undefined && testresultData.betallowcomp=='1'))
       this.opencompoentscase(testresultData);
       else
       this.compolist('component_list', testresultData.learning_room_id, testresultData.dlr_id);
      
      // console.log(""+testresultData.learning_room_id+","+testresultData.dlr_id);
       scrollToTop();
    }

    returnrepeatretest(testresultData)  {
        this.opencompoentscase(testresultData);
    }




    openthecompoents(data) {
        //console.log(data);
       
         
        if (data.look_before !=undefined &&  data.look_before == "Y" && data.status != 'completed') {
			/* window.swal({
			     title: 'Note',
			     text: 'Before continue this component, You need confirm the announcement details of the current component.',
			     type: 'warning',
			     showCancelButton: true,
			     confirmButtonColor: '#3085d6',
			     cancelButtonColor: '#d33',
			     confirmButtonText: 'Open'
			 }).then((result) => {
			     if (result) {
			         this.opencompoentscase(data);
			     }
			 });*/
            this.opencompoentscase(data); 
            //message("Note", "Before continue this component, You need confirm the announcement details of the current component.");
        } else if (data.compo_type == "feedbackform" && data.status == "completed") {
            if(data.fb_reopen==1)
            {
                //message("", "This component is already completed.");
                window.swal({
                    //title: 'View!',
                    text: 'Do you want to view this again?',
                   // type: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#14a430',
                    cancelButtonColor: '#0082c9',
                    animation: false,
                    confirmButtonText: 'Ok'
                }).then((result) => {
                    if (result) {
                        this.opencompoentscase(data);
                    }
                });
            }
            else if(data.fb_reopen==0)
            {
                message("", "This component is already completed.");
                /*window.swal({
                    //title: 'View!',
                    text: 'Do you want to view this again?',
                   // type: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#14a430',
                    cancelButtonColor: '#0082c9',
                    animation: false,
                    confirmButtonText: 'Ok'
                }).then((result) => {
                    if (result) {
                        this.opencompoentscase(data);
                    }
                });
                //this.opencompoentscase(data);*/
            }
        } else if (data.status == "completed") {
            if (data.compo_type != "anouncement" && data.Isvisible) {
                this.opencompoentscase(data);
            } else {
                window.swal({
                    //title: 'View!',
                    text: 'Do you want to view this again?',
                   // type: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#14a430',
                    cancelButtonColor: '#0082c9',
                    animation: false,
                    confirmButtonText: 'Ok'
                }).then((result) => {
                    if (result) {
                        this.opencompoentscase(data);
                    }
                });
            }
        } else {
            this.opencompoentscase(data);
        }
        composcroll();
        contentResizeLoad();
    }
    componentDidMount() {
        this.getLearningRoom(this.lr_id, this.dlrid);
        setTimeout(() => {
            jQuery(".guided_path li").removeClass("active-accordion");
            jQuery('.lr' + this.lr_id).addClass("active-accordion");
            jQuery('.mlr_' + this.lr_id).parents('li').addClass("active-accordion");
            jQuery('.mrlr_' + this.lr_id).parents('li').addClass("active-accordion");
            jQuery('#semana-scroll').tinyscrollbar();
        }, 500);
        // showLargeLeftMenu();
       
    }
    componentWillReceiveProps(nextProps) {
        this.lr_id = (nextProps.lr_id == 0) ? this.state.defaultLrID : nextProps.lr_id;
        this.dlrid = (nextProps.dlr_id == 0) ? 0 : nextProps.dlr_id;
        setTimeout(() => {
            reactLoader("hide");
            jQuery(".guided_path li").removeClass("active-accordion");
            jQuery('.lr' + this.lr_id).addClass("active-accordion");
            jQuery('.mlr_' + this.lr_id).parents('li').addClass("active-accordion");
            jQuery('.mrlr_' + this.lr_id).parents('li').addClass("active-accordion");
            this.getLearningRoom(this.lr_id, this.dlrid);
        }, 500);
    }
    updateCourse(course_id, learner_id, course_name){
        //alert(course_id);
        reactLoader("show", "Please wait...");
        fetch(domainUrl + 'guidedpath/course', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                learner_id: learner_id,
                course_id: course_id,
                course_name: course_name
            })
        })
        reactLoader("hide");
    }
    //console.log(this.state.lrcomponents);
    getdividcomponents(did) {
        let strv1 = this.state.lrcomponents[did].map((key, index) => {
            if(index == 0){
                return key
            }
        });
        
        
        let renderdata = <div>
            {(strv1[0].lr_room_id == "6651") ?
            <ul class="0">
                <li style={{padding: '0px 20px 0px 0px', height: '33px'}}>{(strv1[0].firstname)}</li>
                <li style={{padding: '0px 20px 0px 0px', height: '33px'}}>{(strv1[0].primaryemail)}</li>
                <li style={{padding: '0px 20px 0px 0px', height: '33px'}}>{(strv1[0].mobile)}</li>
                <li style={{padding: '0px 20px 0px 0px', height: '33px'}}>{(strv1[0].college)}</li>
                <li style={{padding: '0px 20px 0px 0px', height: '33px'}}> Your Total Score : {(strv1[0].total_val)} / 60</li>
            </ul> :<span></span>
            }
        </div>

        let tabledata = <div>
        {(strv1[0].lr_room_id == "6651") ?
        <table style={{border : '1px solid #c1c1c175', width: '100%'}}>
            <tr style={{border : '1px solid #c1c1c175', width: '100%', backgroundColor : '#76b8e4', height: '34px'}}>
                <th>Segment</th>
                <th>No.of Questions</th>
                <th>Answered Correctly</th>
                <th>% Scored</th>
            </tr>
            <tr style={{border : '1px solid #c1c1c175', width: '100%', height: '34px'}}>
                <td style={{border : '1px solid #c1c1c175'}}>BFSI Marketing</td>
                <td style={{border : '1px solid #c1c1c175',textAlign: 'center'}}>12</td>
                <td style={{border : '1px solid #c1c1c175',textAlign: 'center'}}>{(strv1[0].bfsi_marketing_val)}</td>
                <td style={{border : '1px solid #c1c1c175',textAlign: 'center'}}>{(strv1[0].bfsi_val)} %</td> 
            </tr>
            <tr style={{border : '1px solid #c1c1c175', width: '100%', height: '34px'}}>
                <td style={{border : '1px solid #c1c1c175'}}>Capital Markets</td>
                <td style={{border : '1px solid #c1c1c175',textAlign: 'center'}}>20</td>
                <td style={{border : '1px solid #c1c1c175',textAlign: 'center'}}>{(strv1[0].capital_markets_val)}</td>
                <td style={{border : '1px solid #c1c1c175',textAlign: 'center'}}>{(strv1[0].capital_val)} %</td>
            </tr>
            <tr style={{border : '1px solid #c1c1c175', width: '100%', height: '34px'}}>
                <td style={{border : '1px solid #c1c1c175'}}>Banking</td>
                <td style={{border : '1px solid #c1c1c175',textAlign: 'center'}}>16</td>
                <td style={{border : '1px solid #c1c1c175',textAlign: 'center'}}>{(strv1[0].banking_val)}</td>
                <td style={{border : '1px solid #c1c1c175',textAlign: 'center'}}>{(strv1[0].bank_val)} %</td>
            </tr>
            <tr style={{border : '1px solid #c1c1c175', width: '100%', height: '34px'}}>
                <td style={{border : '1px solid #c1c1c175'}}>Insurance</td>
                <td style={{border : '1px solid #c1c1c175',textAlign: 'center'}}>12</td>
                <td style={{border : '1px solid #c1c1c175',textAlign: 'center'}}>{(strv1[0].insurance_val)}</td>
                <td style={{border : '1px solid #c1c1c175',textAlign: 'center'}}>{(strv1[0].insu_val)} %</td>
            </tr>
            <tr style={{border : '1px solid #c1c1c175', width: '100%', backgroundColor : '#76b8e4', height: '34px'}}>
                <th>Total</th>
                <th>60</th>
                <th>{(strv1[0].total_val)}</th>
                <th>{(strv1[0].tot_val)} %</th> 
            </tr>
        </table> :<span></span>
        }
        </div>
        
        let strv = this.state.lrcomponents[did].map((key, index) => {
            if(key.lr_room_id == "6651") {
                return <div>
                    <ul class="0">
                        <li style={{marginTop:'25px', padding: '0px 20px 0px 0px', height: '33px', fontWeight: 'bold'}}>({(key.section)})</li>
                        <li style={{padding: '0px 20px 0px 0px', height: '50px'}}><span style={{marginTop: '13px',padding: '2px', color: '#0659ea'}}>{(key.id)}. {(key.question)}</span></li>
                        <li style={{padding: '0px 20px 0px 0px', height: '33px', fontSize: '14px'}}>A. {(key.option_a)} {(key.correct_ans == key.option_a) ? <span style={{marginLeft:'10px', color: 'green'}}><i className="fa fa-check"></i></span> : <span></span>}</li>
                        <li style={{padding: '0px 20px 0px 0px', height: '33px', fontSize: '14px'}}>B. {(key.option_b)} {(key.correct_ans == key.option_b) ? <span style={{marginLeft:'10px', color: 'green'}}><i className="fa fa-check"></i></span> : <span></span>}</li>
                        <li style={{padding: '0px 20px 0px 0px', height: '33px', fontSize: '14px'}}>C. {(key.option_c)} {(key.correct_ans == key.option_c) ? <span style={{marginLeft:'10px', color: 'green'}}><i className="fa fa-check"></i></span> : <span></span>}</li>
                        <li style={{padding: '0px 20px 0px 0px', height: '33px', fontSize: '14px'}}>D. {(key.option_d)} {(key.correct_ans == key.option_d) ? <span style={{marginLeft:'10px', color: 'green'}}><i className="fa fa-check"></i></span> : <span></span>}</li>
                        <li style={{padding: '0px 20px 0px 0px', height: '33px', fontSize: '14px'}}><span style={{marginTop: '13px',padding: '2px'}}>
                            Your Answer : {(key.id == 1) ? (key.ans_q1): (key.id == 2) ? key.ans_q2 : (key.id == 3) ? key.ans_q3 : (key.id == 4) ? key.ans_q4 : (key.id == 5) ? key.ans_q5 : (key.id == 6) ? key.ans_q6 : (key.id == 7) ? key.ans_q7 : (key.id == 8) ? key.ans_q8 : (key.id == 9) ? key.ans_q9 : (key.id == 10) ? key.ans_q10 : (key.id == 11) ? key.ans_q11 : (key.id == 12) ? key.ans_q12 : (key.id == 13) ? key.ans_q13 : (key.id == 14) ? key.ans_q14 : (key.id == 15) ? key.ans_q15 : (key.id == 16) ? key.ans_q16 : (key.id == 17) ? key.ans_q17 : (key.id == 18) ? key.ans_q18 : (key.id == 19) ? key.ans_q19 : (key.id == 20) ? key.ans_q20 : (key.id == 21) ? key.ans_q21 : (key.id == 22) ? key.ans_q22 : (key.id == 23) ? key.ans_q23 : (key.id == 24) ? key.ans_q24 : (key.id == 25) ? key.ans_q25 : (key.id == 26) ? key.ans_q26 : (key.id == 27) ? key.ans_q27 : (key.id == 28) ? key.ans_q28 : (key.id == 29) ? key.ans_q29 : (key.id == 30) ? key.ans_q30 : (key.id == 31) ? key.ans_q31 : (key.id == 32) ? key.ans_q32 : (key.id == 33) ? key.ans_q33 : (key.id == 34) ? key.ans_q34 : (key.id == 35) ? key.ans_q35 : (key.id == 36) ? key.ans_q36 : (key.id == 37) ? key.ans_q37 : (key.id == 38) ? key.ans_q38 : (key.id == 39) ? key.ans_q39 : (key.id == 40) ? key.ans_q40 : (key.id == 41) ? key.ans_q41 : (key.id == 42) ? key.ans_q42 : (key.id == 43) ? key.ans_q43 : (key.id == 44) ? key.ans_q44 : (key.id == 45) ? key.ans_q45 : (key.id == 46) ? key.ans_q46 : (key.id == 47) ? key.ans_q47 : (key.id == 48) ? key.ans_q48 : (key.id == 49) ? key.ans_q49 : (key.id == 50) ? key.ans_q50 : (key.id == 51) ? key.ans_q51 : (key.id == 52) ? key.ans_q52 : (key.id == 53) ? key.ans_q53 : (key.id == 54) ? key.ans_q54 : (key.id == 55) ? key.ans_q55 : (key.id == 56) ? key.ans_q56 : (key.id == 57) ? key.ans_q57 : (key.id == 58) ? key.ans_q58 : (key.id == 59) ? key.ans_q59 : (key.id == 60) ? key.ans_q60 : ""}
                            </span></li>
                        <li style={{padding: '0px 20px 0px 0px', height: '33px', fontSize: '14px'}}>Score : 
                            {(key.id == 1) ? (key.correct_ans == key.ans_q1) ? "1" : "0" : (key.id == 2) ? (key.correct_ans == key.ans_q2) ? "1" : "0" : (key.id == 3) ? (key.correct_ans == key.ans_q3) ? "1" : "0" : (key.id == 4) ? (key.correct_ans == key.ans_q4) ? "1" : "0" : (key.id == 5) ? (key.correct_ans == key.ans_q5) ? "1" : "0" : (key.id == 6) ? (key.correct_ans == key.ans_q6) ? "1" : "0" : (key.id == 7) ? (key.correct_ans == key.ans_q7) ? "1" : "0" : (key.id == 8) ? (key.correct_ans == key.ans_q8) ? "1" : "0" : (key.id == 9) ? (key.correct_ans == key.ans_q9) ? "1" : "0" : (key.id == 10) ? (key.correct_ans == key.ans_q10) ? "1" : "0" : (key.id == 11) ? (key.correct_ans == key.ans_q11) ? "1" : "0" : (key.id == 12) ? (key.correct_ans == key.ans_q12) ? "1" : "0" : (key.id == 13) ? (key.correct_ans == key.ans_q13) ? "1" : "0" : (key.id == 14) ? (key.correct_ans == key.ans_q14) ? "1" : "0" : (key.id == 15) ? (key.correct_ans == key.ans_q15) ? "1" : "0" : (key.id == 16) ? (key.correct_ans == key.ans_q16) ? "1" : "0" : (key.id == 17) ? (key.correct_ans == key.ans_q17) ? "1" : "0" : (key.id == 18) ? (key.correct_ans == key.ans_q18) ? "1" : "0" : (key.id == 19) ? (key.correct_ans == key.ans_q19) ? "1" : "0" : (key.id == 20) ? (key.correct_ans == key.ans_q20) ? "1" : "0" : (key.id == 21) ? (key.correct_ans == key.ans_q21) ? "1" : "0" : (key.id == 22) ? (key.correct_ans == key.ans_q22) ? "1" : "0" : (key.id == 23) ? (key.correct_ans == key.ans_q23) ? "1" : "0" : (key.id == 24) ? (key.correct_ans == key.ans_q24) ? "1" : "0" : (key.id == 25) ? (key.correct_ans == key.ans_q25) ? "1" : "0" : (key.id == 26) ? (key.correct_ans == key.ans_q26) ? "1" : "0" : (key.id == 27) ? (key.correct_ans == key.ans_q27) ? "1" : "0" : (key.id == 28) ? (key.correct_ans == key.ans_q28) ? "1" : "0" : (key.id == 29) ? (key.correct_ans == key.ans_q29) ? "1" : "0" : (key.id == 30) ? (key.correct_ans == key.ans_q30) ? "1" : "0" : (key.id == 31) ? (key.correct_ans == key.ans_q31) ? "1" : "0" : (key.id == 32) ? (key.correct_ans == key.ans_q32) ? "1" : "0" : (key.id == 33) ? (key.correct_ans == key.ans_q33) ? "1" : "0" : (key.id == 34) ? (key.correct_ans == key.ans_q34) ? "1" : "0" : (key.id == 35) ? (key.correct_ans == key.ans_q35) ? "1" : "0" : (key.id == 36) ? (key.correct_ans == key.ans_q36) ? "1" : "0" :  (key.id == 37) ? (key.correct_ans == key.ans_q37) ? "1" : "0" : (key.id == 38) ? (key.correct_ans == key.ans_q38) ? "1" : "0" : (key.id == 39) ? (key.correct_ans == key.ans_q39) ? "1" : "0" : (key.id == 40) ? (key.correct_ans == key.ans_q40) ? "1" : "0" : (key.id == 41) ? (key.correct_ans == key.ans_q41) ? "1" : "0" : (key.id == 42) ? (key.correct_ans == key.ans_q42) ? "1" : "0" : (key.id == 43) ? (key.correct_ans == key.ans_q43) ? "1" : "0" : (key.id == 44) ? (key.correct_ans == key.ans_q44) ? "1" : "0" : (key.id == 45) ? (key.correct_ans == key.ans_q45) ? "1" : "0" :  (key.id == 46) ? (key.correct_ans == key.ans_q46) ? "1" : "0" : (key.id == 47) ? (key.correct_ans == key.ans_q47) ? "1" : "0" : (key.id == 48) ? (key.correct_ans == key.ans_q48) ? "1" : "0" : (key.id == 49) ? (key.correct_ans == key.ans_q49) ? "1" : "0" : (key.id == 50) ? (key.correct_ans == key.ans_q50) ? "1" : "0" : (key.id == 51) ? (key.correct_ans == key.ans_q51) ? "1" : "0" : (key.id == 52) ? (key.correct_ans == key.ans_q52) ? "1" : "0" : (key.id == 53) ? (key.correct_ans == key.ans_q53) ? "1" : "0" : (key.id == 54) ? (key.correct_ans == key.ans_q54) ? "1" : "0" : (key.id == 55) ? (key.correct_ans == key.ans_q55) ? "1" : "0" : (key.id == 56) ? (key.correct_ans == key.ans_q56) ? "1" : "0" : (key.id == 57) ? (key.correct_ans == key.ans_q57) ? "1" : "0" : (key.id == 58) ? (key.correct_ans == key.ans_q58) ? "1" : "0" : (key.id == 59) ? (key.correct_ans == key.ans_q59) ? "1" : "0" : (key.id == 60) ? (key.correct_ans == key.ans_q60) ? "1" : "0" : ""}
                        </li>
                    </ul>
                </div>
            } 
            
            if(key.lr_room_id != "6651") {
                return <li key={`divid_comp_${index}`}>
                    {key.is_ag > 0 &&
                        <span style={{ float: 'left', marginRight: '3px' }}>
                            <img src={process.env.PUBLIC_URL + '/images/img_action_goal.gif'} style={{ height: '40px' }} title="Action Goal" />
                        </span>
                    }


                    {(key.compo_type == "learningmaterial" && this.lr_id != "6651") ?
                        <span style={{ float: 'left', marginRight: '3px' }}>
                            <img src={process.env.PUBLIC_URL + '/images/mn.PNG'} style={{ height: '40px' }} title="Go To Material" />
                        </span> :
                        (this.lr_id == "6651") ? <div></div> :
                        <div className={key.spanclass} title={key.name}></div>
                    }

                    {(this.lr_id != "6651") ?
                    <span className={key.status}></span> :
                    <span></span>
                    }

                    {(key.compo_type == "learningmaterial" && this.lr_id != "6651") ?
                        <a href={key.url} target="_blank"><span onClick={e => this.updateCourse(key.course_id, key.learner_id, key.name)} style={{ marginLeft: '4px' }}>Go To Course</span></a>:
                        (this.lr_id == "6651") ?
                        <span></span>:
                        <a href="javascript:void(0);" onClick={(key.divider_status != 0) ? e => this.openthecompoents(key) : e => this.predividernotcompleted()}>{key.name}</a>
                    }
                </li>
            }
        });
        //return renderdata.prepend(strv);
        return ( <div> {renderdata} {tabledata} {strv} </div> );
    }
    render() {
        let ecoach_exists = getUserData("ecoach_exists", true);
        let corporateID = getUserData('corporateID', true); 
        const { lr_id, dlr_id } = this.props;
        let componentBlock = null;
        if (this.state.component_type) {
            componentBlock = <section id="semana-scroll" className="scrollbar1">
                <section className="scrollbar">
                    <section className="track">
                        <section className="thumb"></section>
                    </section>
                </section>
                <section className="viewport viewport1">
                    <section className="overview">
                        {this.state.componentPanel}

                    </section>
                </section>
                <div className="score-box">
                    <img src={process.env.PUBLIC_URL + '/images/completed.png'} alt="" align="absmiddle" border="0" /> Completed <img src={process.env.PUBLIC_URL + '/images/incompleted.png'} alt="" border="0" /> Partially Completed
                </div>
            </section>;
        } else {
            componentBlock = this.state.componentPanel;
        }
        return (<section id="contentsection" className="contentarea">
            <WritingNotePad name={this.state.learning_room_name} lr_id={this.lr_id} dlr_id={this.dlrid} notesList={this.goToNotesList} />
            <div className="title-bg">
                <h1>
                    <span><img src={process.env.PUBLIC_URL + '/images/img-lr.png'} align="absmiddle" alt="" border="0" /></span>
                    <div className="lr-title"></div>
                    <div className="lr-room">{this.state.learning_room_name}</div>
                </h1>
                <div className="header-buttons">
                    <ul>
                        {(ecoach_exists!= false)?<li><a href="javascript:void(0);" onClick={() => this.goToNotesList('ec_profile')}><img src={process.env.PUBLIC_URL + '/images/profile-icon.png'} alt="E-Coach Profile" title="E-Coach Profile" /></a></li>:null}
                        {(corporateID!=77) ?
                        <li><a href="javascript:void(0);" data-modal-id="popup2"><img src={process.env.PUBLIC_URL + '/images/writting-pad-grn.png'} alt="Writing Pad" title="Writing Pad" /></a></li> : ''}

                        {(!this.state.component_type) && (corporateID!=77) && <li><a href="javascript:void(0);" onClick={() => this.compolist('component_list', this.lr_id, this.dlrid)}><img src={process.env.PUBLIC_URL + '/images/back-icon.png'} alt="Back" title="Back" /></a></li> }
                    </ul>
                </div>
            </div>
            <div className="main-home"> {componentBlock} </div>
        </section>);
    }
}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/Componetlist.js